// src/helpers/factories/settings/settingsDashboardsCardFactory.ts
var settingsDashboardsCardFactory = (dashboards) => {
  return Object.values(dashboards).map((dashboard) => ({
    id: dashboard.id,
    title: dashboard.name
  }));
};

export { settingsDashboardsCardFactory };
